let rafId: number | null = null;

export function updateGlobalStickyState() {
  if (rafId) return;

  rafId = requestAnimationFrame(() => {
    rafId = null;

    const anyVisible = document.querySelector(".article-card.v_showStickyBar");

    document.documentElement.classList.toggle(
      "v_showingStickySummary",
      !!anyVisible,
    );
  });
}
